import React from "react";
import {
  FormatBalance,
  FormatDate,
  GetTransactionsTypeIcon,
} from "../../../../helper";

const TransactionItem = ({
  transaction,
  activeTransaction,
  currencySymbol,
  type = "accounts",
}) => {
  return (
    <div
      className={`recent-transaction-item ${
        activeTransaction && activeTransaction.id === transaction.id
          ? "recent-transaction-item-active"
          : ""
      }`}
    >
      {/* Left Section */}
      <div className="recent-transaction-left">
        {GetTransactionsTypeIcon(type, transaction.type)}

        <div className="recent-transaction-text flex flex-col max-md:max-w-[12rem] md:max-w-[15rem] lg:max-w-[22rem]">
          <p className="recent-transaction-remarks">{transaction.remarks}</p>
          <div className="flex-col justify-center items-center gap-2.5 flex">
            <div className="recent-transaction-date">
              {FormatDate(transaction.date, "d m, yyyy")}
            </div>
          </div>
        </div>
      </div>

      {/* Right Section */}
      <div
        className={`recent-transaction-amount ${
          transaction.type === "Credit"
            ? "recent-transaction-credit-amount"
            : "recent-transaction-debit-amount"
        }`}
      >
        <span>{transaction.type === "Credit" ? "+" : "-"}</span>
        <span>{currencySymbol}</span>
        <span>{FormatBalance(transaction.amount, type === "crypto")}</span>
      </div>
    </div>
  );
};

export default TransactionItem;
